import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

const mutateUpdateParkDoc = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${PARK_DOCUMENT}/park/${id}`, data);
};

const useUpdateParkDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateParkDoc,
    ...queryParams,
  });

export default useUpdateParkDocMutation;
